import React, { FunctionComponent } from 'react';
import { HeadProvider, Style } from 'react-head';

type Props = { brandStyles?: string; children: React.ReactNode };

const Layout: FunctionComponent<React.PropsWithChildren<Props>> = ({
    brandStyles,
    children
}) => {
    return (
        <>
            <HeadProvider>
                <Style>{brandStyles}</Style>
            </HeadProvider>
            {children}
        </>
    );
};

export default Layout;
